const initState = {
  authError: "",
  uid: "",
  requested: false,
  registered: false,
  user: null,
  loading: false,
  passwordLoading: false,
  subAdmin: [],
  hasMoreAdmin: true,
  subAdminLastDocument: null,
};
const authReducer = (state = initState, action) => {
  switch (action.type) {
    case "DELETE_SUB_ADMIN":
      return {
        ...state,
        subAdmin: state.subAdmin.filter((items) => items.id !== action.payload),
      };
    case "UPGRADE_SUB_ADMIN_DATA":
      let { name, id, email, permissions } = action.payload;
      return {
        ...state,
        subAdmin: state.subAdmin.map((items) =>
          items.id == id
            ? { ...items, name: name, email: email, permissions: permissions }
            : items
        ),
      };
    case "ADD_SUB_ADMIN":
      return {
        ...state,
        subAdmin: [...state.subAdmin, action.payload],
      };
    case "GET_SUB_ADMINS":
      return {
        ...state,
        subAdmin: action.payload.data,
        hasMoreAdmin: action.payload.hasMore,
        subAdminLastDocument: action.payload.lastDocument,
      };
    case "MORE_GET_SUB_ADMINS":
      return {
        ...state,
        subAdmin: [...state.subAdmin, ...action.payload.data],
        hasMoreAdmin: action.payload.hasMore,
        subAdminLastDocument: action.payload.lastDocument,
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        uid: action.user.id,
        user: { ...action.user },
        authError: "",
      };
    case "UPDATE_USER_DEVICE_TOKEN":
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    case "LOGIN_FAIL":
      localStorage.clear();
      return {
        ...state,
        uid: "",
        authError: action.error.message,
      };
    case "LOGOUT_SUCCESS":
      return {
        ...state,
        authError: "",
        uid: "",
        registered: false,
        user: null,
      };
    case "ACTION_REQUEST":
      return {
        ...state,
        requested: true,
      };
    case "ACTION_REQUEST_END":
      return {
        ...state,
        requested: false,
      };
    case "LOGIN_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "LOGIN_REQUEST_END":
      return {
        ...state,
        loading: false,
      };
    case "ACTION_FORGET_REQUEST":
      return {
        ...state,
        passwordLoading: true,
      };
    case "ACTION_FORGET_REQUEST_END":
      return {
        ...state,
        passwordLoading: false,
      };
    default:
      return {
        ...state,
      };
  }
};
export default authReducer;
